import { render, staticRenderFns } from "./SettingsReasons.vue?vue&type=template&id=c62d5aa4&scoped=true&"
import script from "./SettingsReasons.vue?vue&type=script&lang=js&"
export * from "./SettingsReasons.vue?vue&type=script&lang=js&"
import style0 from "./SettingsReasons.vue?vue&type=style&index=0&id=c62d5aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62d5aa4",
  null
  
)

export default component.exports